// extracted by mini-css-extract-plugin
export var button = "_mw-2";
export var card = "_mw-0";
export var closeButtonContainer = "_mw-3";
export var iconContainer = "_mw-1";